import api from './axios';

export async function fetchPartnerships(params = {}) {
  const { data } = await api.get('/partnerships', { params });
  return data.items || [];
}

export async function fetchPartnershipById(id) {
  const { data } = await api.get(`/partnerships/${id}`);
  return data.item;
}

export async function createPartnership(payload) {
  const { data } = await api.post('/partnerships', payload);
  return data.item;
}

export async function updatePartnership(id, payload) {
  const { data } = await api.patch(`/partnerships/${id}`, payload);
  return data.item;
}

export async function deletePartnership(id) {
  await api.delete(`/partnerships/${id}`);
  return id;
}

export async function uploadPartnershipContract(file, onProgress) {
  const formData = new FormData();
  formData.append('contract', file);
  const { data } = await api.post('/partnerships/upload-contract', formData, {
    onUploadProgress: onProgress
      ? (e) => {
          const percent = e.total ? Math.round((e.loaded * 100) / e.total) : 0;
          onProgress(percent);
        }
      : undefined,
  });
  return data;
}
